exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blog-img{padding:21px;border-radius:6px;box-shadow:-2px -1px 9px 2px #ccc9c9}.panel-body{padding:25px}.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.col-xs-12{margin-bottom:20px}.specialli{margin:10px;font-size:17.5px}ol{list-style:square;margin-left:30px;margin-top:20px}.img-responsive{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49f8cfa0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/blogs/Blog.vue
// module id = 197
// module chunks = 0